import React from "react";
import PrintChallan from "./PrintChallan";

function PublicChallanDownload() {
  return <PrintChallan />;
}

export default PublicChallanDownload;
